import { ConversationSchemaDbParser } from "@redotech/redo-support-common/conversation/conversation-schema-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getConversationsByIds = {
  name: "getConversationsByIds" as const,
  input: z.object({ conversationIds: z.array(zExt.objectId()) }),
  output: z.object({ conversations: z.array(ConversationSchemaDbParser) }),
};
